import { atom } from 'recoil';

export const shopId = atom({
  key: 'shopId',
  default: undefined,
});
